import Tasks from "../../../collection/tasks";
import View from "../../view";

import { ask } from "../../../utils/popups";
import { beginLock, endLock } from "../../../loader";
import { del } from "../../../http/api";
import { fetch } from "../../../collection/comments";






export default View.extend( {

    template: 'module/tasks/sublist',

    initialize(options = {}) {
        const { filters = {}, page = 1, activeId, ...otherOptions } = options;
        this.filters_ = { ...filters };
        this.page_ = page;
        this.activeId_ = activeId;

        options.actions = {
            
            defaults: 'edit',
        
            edit: (current) => 
                this.trigger( 'edit', current ),
            
            destroy: {
            
                disabled: (current) => 
                    !current || !current.capabilities_.delete,

                handler: (current) =>
                    ask( 'issue::modal delete - confirmation text', undefined, 'actions::yes', 'actions::no',
                        () => del( `/tasks/${current.id}` ).blocking( this ).cerebellum().execute() )
                        .then( () => {
                            // deleting last task on the page?
                            if (this.tasks_.total == (this.page_ - 1) * 7 + 1)
                                // triggering page will force page change + reload + hash change
                                this.trigger( 'Paging:page', this.page_ - 1 );
                            else 
                                this.fetch();
                        } )
            }

        };

        this.tasks_ = new Tasks( [], { actions: options.actions } );

        this.listenTo( this.tasks_, 'activate deactivate',
            activeId => this.trigger( 'row', activeId ) );

        this.listenTo( this.tasks_, 'activate',
            () => {
                const current = this.tasks_.current();
                if (!current.comments_)
                    fetch( current.id ).then( ({ array }) =>
                        current.trigger( 'comments:load', current.comments_ = array ) );
            } );

        View.prototype.initialize.call( this, otherOptions );
    },

    fetch() { 
        const { bbox, ...otherFilters } = this.filters_;
        const filters = {
            bbox: bbox.join( ',' ),
            ...Tasks.getHttpFilters( { filters: otherFilters, activeId: this.activeId_ } )
        };

        return beginLock( this ), 
            this.tasks_.seq( filters, this.page_, this.activeId_ )
                .finally( () => endLock( this ) );
    },

    serialize() {
        return {
            collection: this.tasks_,
        };
    },

    afterRender(context, firstTime) {
        if (firstTime)
            this.tasks_.plugActionSource( this.Grid );
    },

    [View.event( 'Paging:page' )](page) {
        return this.page_ = page, this.fetch();
    },

} );


// WEBPACK FOOTER //
// ./src/js/view/module/tasks/sublist.js